module.exports = __webpack_public_path__ + "static/media/caterpillar_white.9c13dbae.svg";